<label class="checkbox-container">
    <input type="checkbox"  [formControl]="inputFormControl">
    <div class="input-checkbox"></div>
</label>
<div class="has-error mt-1 mb-1" *ngIf="inputFormControl.touched  && (inputFormControl.errors?.required)">
  <div>Please agree the terms and conditions</div> 
</div>